import { render, staticRenderFns } from "./u-card-elevated-default.vue?vue&type=template&id=5f907352&scoped=true&"
import script from "./u-card-elevated-default.vue?vue&type=script&lang=js&"
export * from "./u-card-elevated-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f907352",
  null
  
)

export default component.exports